import { MediaDataTypes } from "@/components/atoms/media/MediaData";
import { ImageWithCaption } from "@/components/molecules/imageWithCaption";
import { Box, chakra } from "@chakra-ui/react";

export interface ImageCaptionComponentProps {
  image: MediaDataTypes;
  imgAspectRatio?: string;
  caption?: string;
  isFullWidth?: boolean;
}

export default chakra(ImageCaptionComponent);
function ImageCaptionComponent({
  image,
  imgAspectRatio,
  caption,
  isFullWidth = false,
}: ImageCaptionComponentProps) {
  return (
    <Box as="section" maxW={isFullWidth ? "none" : "contentmodule"} mx="auto">
      {image && (
        <ImageWithCaption
          image={image}
          imgAspectRatio={imgAspectRatio}
          caption={caption}
        />
      )}
    </Box>
  );
}
